export function getLabelForLegendItem(legendItem, i18n) {
    const label = legendItem.label;
    if (typeof label === 'string') {
        return label;
    }
    return i18n.translatable(label);
}
//# sourceMappingURL=get-label-for-legend-item.js.map